import './ModuleDetails.scss';
import { ModuleDetailsHeader } from './ModuleDetailsHeader/ModuleDetailsHeader';
import { ModuleDetailsDescription } from 'pages/LearningHub/ModuleDetails/ModuleDetailsDescription/ModuleDetailsDescription';
import { ModuleCertificates } from './ModuleCertificates/ModuleCertificates';
import { ModuleContents } from './ModuleContents/ModuleContents';
import { ModuleCTA } from 'components/ModuleCTA/ModuleCTA';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { LoadingPlaceholder } from '@trackman/web-shared-components';
import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import { isModuleCompleted, isModuleStarted } from 'utilities/learningModuleStatus';

export const ModuleDetailsPage = () => {
  const slug = useParams().slug ?? '';
  const service = useServices().learningHubService;
  const moduleDetails = useQuery({
    queryKey: ['moduleDetails', slug],
    queryFn: () => service.getModuleDetails(slug),
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });

  const tableOfContents = useQuery({
    queryKey: ['moduleContents', moduleDetails.data?.id],
    queryFn: () => service.getModuleContents(moduleDetails.data?.id ?? ' '),
    enabled: !!moduleDetails.data?.id,
    refetchOnWindowFocus: false,
  });

  const numberOfLessons = tableOfContents?.data?.chapters.reduce((acc, chapter) => acc + chapter.lessons.length, 0) ?? 0;
  const numberOfChapterTests =
    tableOfContents?.data?.chapters.reduce((acc, chapter) => {
      if (chapter.chapterTest) {
        return acc + 1;
      } else {
        return acc;
      }
    }, 0) ?? 0;
  const numberOfCertificates = tableOfContents?.data?.certifications.length ?? 0;

  return (
    <>
      {!moduleDetails.isPending && moduleDetails.data && !tableOfContents.isPending && tableOfContents.data ? (
        <ModuleDetailsHeader
          title={moduleDetails.data.title}
          shortDescription={moduleDetails.data.shortDescription}
          navigationPath='/LearningHub'
          imageUrl={moduleDetails.data.imageUrl}
          numberOfCertificates={numberOfCertificates}
          numberOfChapterTests={numberOfChapterTests}
          numberOfLessons={numberOfLessons}
        ></ModuleDetailsHeader>
      ) : (
        <Skeleton variant='text' sx={{ margin: '1.5rem' }} />
      )}
      <div className='module-details-wrapper'>
        {!moduleDetails.isPending && moduleDetails.data && !tableOfContents.isPending && tableOfContents.data ? (
          <>
            <div className='content'>
              <ModuleDetailsDescription description={moduleDetails.data.fullDescription}></ModuleDetailsDescription>
              <ModuleCertificates certificationTests={moduleDetails.data.certificationTests}></ModuleCertificates>
            </div>
            <div className='module-contents-wrapper'>
              <ModuleContents
                contents={tableOfContents.data}
                isModuleCompleted={isModuleCompleted(tableOfContents?.data)}
                isModuleStarted={isModuleStarted(tableOfContents?.data)}
                slug={slug}
              ></ModuleContents>
            </div>
            <div className='fixed-module-cta'>
              <ModuleCTA
                isModuleCompleted={isModuleCompleted(tableOfContents?.data)}
                isModuleStarted={isModuleStarted(tableOfContents?.data)}
                slug={slug}
              ></ModuleCTA>
            </div>
          </>
        ) : (
          <LoadingPlaceholder sx={{ width: '100%' }} />
        )}
      </div>
    </>
  );
};
